export default ["border", "borderT", "borderR", "borderB", "borderL", "borderX", "borderY"];
